document.addEventListener("DOMContentLoaded", function () {

    slickSliderHome();
    contdownOferta();
    handleMenuDesk();
    orderCustom();
    changeViewGrid();
    orderCustomMobile();
    voltarTopo();
    slickThumbs();
    zoomPdp();
    compreJunto();
    handleDescricaoPdp();
    compraFlutuante();
    slickProdutosRelacionados();
    variationPdp();

    setTimeout(() => {
        variationCard();
    }, 2000);

    function slickSliderHome() {
        if ($('body').hasClass('nossa-loja')) {
            $('.slider-imagens').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                centerMode: true,
                centerPadding: '100px',
                responsive: [
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '30px',
                        }
                    }
                ]
            });
        } else {
            $('.slider-imagens').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true
            });
        }

        $('section.encontre-por-categorias .banners-grid').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 760,
                    settings: {
                        slidesToShow: 2.5,
                        infinite: false
                    }
                }
            ]
        });

        if (window.screen.width < 760) {
            $('.custom-deals .deals').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true
            });
            $('section.galeria-imagens .block-imagens').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: false
            });
            $('section.nossos-servicos .box-flex .right .grid').slick({
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: false
            });
        } else {
            $('body.home-page ul.grid.product-grid').slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: false,
                arrows: true
            });
        }

    }

    $(".cupom-texto .button-copy .copy").on('click', function () {
        var copyText = $(".cupom-texto .button-copy p.cupon-text").text();
        navigator.clipboard.writeText(copyText)
            .then(function () {
                $(".modal-cupom-copiado").show();

                $(".modal-cupom-copiado .close-cupom").on('click', function () {
                    $(".modal-cupom-copiado").hide();
                });
            })
            .catch(function (err) {
                console.error('Erro ao copiar o texto: ', err);
            });
    });

    function contdownOferta() {
        var countdownEls = document.querySelectorAll("[data-countdown]");

        if (!countdownEls.length) return;

        countdownEls.forEach(function (el) {
            var endDate = el.getAttribute("data-countdown");
            if (!endDate) return;

            var countDownDate = new Date(endDate).getTime();
            if (isNaN(countDownDate)) return;

            // Garante que os elementos internos existam
            var diasEl = el.querySelector(".dias");
            var horasEl = el.querySelector(".horas");
            var minutosEl = el.querySelector(".minutos");
            var segundosEl = el.querySelector(".segundos");

            // Se não existirem, cria automaticamente
            if (!diasEl) {
                diasEl = document.createElement("div");
                diasEl.className = "dias";
                el.appendChild(diasEl);
            }
            if (!horasEl) {
                horasEl = document.createElement("div");
                horasEl.className = "horas";
                el.appendChild(horasEl);
            }
            if (!minutosEl) {
                minutosEl = document.createElement("div");
                minutosEl.className = "minutos";
                el.appendChild(minutosEl);
            }
            if (!segundosEl) {
                segundosEl = document.createElement("div");
                segundosEl.className = "segundos";
                el.appendChild(segundosEl);
            }

            var x = setInterval(function () {
                var now = new Date().getTime();
                var distance = countDownDate - now;

                if (distance < 0) {
                    clearInterval(x);
                    el.innerHTML = "<span class='encerrado'>Oferta encerrada!</span>";
                    return;
                }

                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                diasEl.textContent = days;
                horasEl.textContent = hours;
                minutosEl.textContent = minutes;
                segundosEl.textContent = seconds;
            }, 1000);
        });
    }

    function handleMenuDesk() {

        $("header-menu").on('mouseenter', function() {
            $(this).children('details').prop('open', true);
            $(this).find('.list-menu__item').attr('aria-expanded', true);
            $(this).find("#menu-overlay").addClass('active'); 
        });
        $("header-menu").on('mouseleave', function() {
            $(this).children('details').prop('open', false);
            $(this).find('.list-menu__item').attr('aria-expanded', false);
            $(this).find("#menu-overlay").removeClass('active'); 
        });

        $("#menu-overlay").on("mouseenter click", function() {
            $("header-menu details").prop("open", false);
            $(".list-menu__item").attr("aria-expanded", false);
            $(this).removeClass('active');
        });


        //Hover subs
       $(".header nav.header__inline-menu ul#HeaderMenu-MenuList-1 > li details").on("mouseenter", function () {
            const $this = $(this);
            // Fecha todos os outros antes de abrir o atual
            $(".header nav.header__inline-menu ul#HeaderMenu-MenuList-1 > li details[open]").not($this).removeAttr("open");
            // Abre o item atual
            $this.attr("open", true);
        });

        $(".header nav.header__inline-menu ul#HeaderMenu-MenuList-1 > li details").on("mouseleave", function () {
            // Fecha o item ao sair do hover
            $(this).removeAttr("open");
        });


    }


    $(".cart__ctas p.continuar").on('click', function () {
        $(".drawer__header button.drawer__close").trigger('click');
    });

    $(".menu-drawer__utility-links .icon-close").on('click', function () {
        $("header header-drawer .header__icon").trigger('click');
    });

    if (window.screen.width < 760) {
        $("footer .block-one ul .title").on('click', function () {
            var self = $(this);
            self.toggleClass('active');
            self.siblings('li.content').slideToggle();
        });
    }

    $("form#FacetSortForm .box-left .exibir-itens .qtde-itens .qtde").on('click', function () {
        var self = $(this);
        self.parent().toggleClass('active');
        $("form#FacetSortForm .box-left .exibir-itens .qtde-itens .qtde").removeClass('active');
        self.addClass('active');
        var dataCont = self.data('cont');

        var hasOpen = self.parent().hasClass('active');

        if (!hasOpen) {
            console.log(dataCont);
        }
    });

    function orderCustom() {
        $(".facet-filters__field .select-custom .order-itens .list>div").on('click', function () {
            var self = $(this);
            self.parent().toggleClass('active');

            var filterSelected = self.prop('class');
            var hasOpen = self.parent().hasClass('active');
            if (!hasOpen) {
                if (self.hasClass('selected')) {
                    self.parent().removeClass('active');
                } else {
                    const select = document.querySelector(".facet-filters__field .select__select");
                    if (select) {
                        select.value = filterSelected;
                        // dispara o mesmo evento que ocorre no clique manual
                        select.dispatchEvent(new Event("input", { bubbles: true }));
                        select.dispatchEvent(new Event("change", { bubbles: true }));
                    }
                }
            }

            $(".facet-filters__field .select-custom .order-itens .list>div").removeClass('selected');
            self.addClass('selected');
        });
    }

    const sortSelect = document.querySelector("select[name='sort_by']");
    if (sortSelect) {
        sortSelect.addEventListener("change", function () {
            setTimeout(() => {
                orderCustom();
            }, 2000);
        });
    }

    function orderCustomMobile() {
        $(".facets-container .ordenar.mobile-only .list .content>div").on('click', function () {
            var self = $(this);

            var filterSelected = self.prop('class');
            const select = document.querySelector(".facet-filters__field .select__select");
            if (select) {
                select.value = filterSelected;
                // dispara o mesmo evento que ocorre no clique manual
                select.dispatchEvent(new Event("input", { bubbles: true }));
                select.dispatchEvent(new Event("change", { bubbles: true }));

                $(".facets-container .ordenar.mobile-only .list .content>div").removeClass('selected');
                self.addClass('selected');

                $(".ordenar.mobile-only").toggleClass('active');
                $(".ordenar.mobile-only .list").slideToggle();

            }

        });
    }

    function changeViewGrid() {
        $(".switch-grid .inner-grid .grid-column").on('click', function () {
            $(this).addClass('active');
            $(".switch-grid .inner-grid .grid-list").removeClass('active');
            $("ul.grid.product-grid").removeClass('grid-list');
        });

        $(".switch-grid .inner-grid .grid-list").on('click', function () {
            $(this).addClass('active');
            $(".switch-grid .inner-grid .grid-column").removeClass('active');
            $("ul.grid.product-grid").addClass('grid-list');
        });
    }

    $(".faq.container .item-faq p.question").on('click', function () {
        $(this).toggleClass('active');
        $(this).siblings('p.answer').slideToggle();
    });

    $("body.collection-page section.section .collection .grid").slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 760,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    $(".collection-hero__description-wrapper button.collection-hero__toggle").on("click", function (e) {
        e.preventDefault();

        let offset = $("#text-seo").offset().top - 155; // ajusta 100px acima
        if (offset < 0) offset = 0; // evita scroll negativo

        $("html, body").animate({
            scrollTop: offset,
        }, 600);
    });

    if (window.screen.width < 760) {
        $('.collection-banners .inner').slick({
            infinite: false,
            slidesToShow: 2.5,
            arrows: false,
            dots: false
        });

        $(".ordenar.mobile-only > span").on('click', function () {
            var self = $(this);
            self.parent().toggleClass('active');
            self.siblings('.list').slideToggle();
        });

        $(".facets-container .ordenar.mobile-only .list .head-ord .fechar, .facets-container .ordenar.mobile-only .overlay").on('click', function () {
            $(".ordenar.mobile-only").toggleClass('active');
            $(".ordenar.mobile-only .list").slideToggle();
        });
    }

    // Script para adicionar classe quando há filtros ativos no mobile
    function checkActiveMobileFilters() {
        const mobileFacetsInner = document.querySelector('body .mobile-facets__inner');

        if (!mobileFacetsInner) return;

        // Verifica se existem filtros ativos
        const activeFilters = document.querySelectorAll(
            '.mobile-facets__inner input[type="checkbox"]:checked, ' +
            '.mobile-facets__inner input[type="radio"]:checked, ' +
            '.mobile-facets__inner select option:checked:not([value=""]), ' +
            '.mobile-facets__inner .active-filter, ' +
            '.mobile-facets__inner .facet-checkbox:checked, ' +
            '.mobile-facets__inner .facet-item.active'
        );

        // Mudança aqui: volta para > 0 em vez de > 1
        if (activeFilters.length > 1) {
            console.log('tem filtros ativos:', activeFilters.length);
            mobileFacetsInner.classList.add('filtro-ativo');
        } else {
            console.log('sem filtros ativos');
            mobileFacetsInner.classList.remove('filtro-ativo');
        }
    }

    // Debounce para evitar execuções excessivas
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Versão com debounce da função
    const debouncedCheck = debounce(checkActiveMobileFilters, 100);

    // Executa a verificação quando a página carrega
    checkActiveMobileFilters();

    // Monitora mudanças nos filtros
    document.addEventListener('change', function (event) {
        if (event.target.closest('.mobile-facets__inner')) {
            checkActiveMobileFilters();
        }
    });

    // Para temas que usam AJAX para filtros
    document.addEventListener('shopify:section:load', checkActiveMobileFilters);

    // Observer otimizado para mudanças no DOM
    const mobileFacetsInner = document.querySelector('.mobile-facets__inner');
    if (mobileFacetsInner) {
        const observer = new MutationObserver(debouncedCheck);

        observer.observe(mobileFacetsInner, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'checked', 'selected']
        });
    }


    function voltarTopo() {
        var $btnVoltar = $(".voltar-topo.mobile-only");

        $(window).on("scroll", function () {
            if ($(this).scrollTop() > 200) {
                $btnVoltar.addClass('active')
            } else {
                $btnVoltar.removeClass('active');
            }
        });

        $btnVoltar.on("click", function (e) {
            e.preventDefault();
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                500
            );
        });
    }

    function slickThumbs() {
        var qtdeThumbs = $(".grid__item.product__media-wrapper media-gallery .thumbnail-slider .thumbnail-list li.thumbnail-list__item").length;
        if (qtdeThumbs > 5) {
            $('.grid__item.product__media-wrapper media-gallery .thumbnail-slider .thumbnail-list').slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                vertical: true,
                verticalSwiping: true,
                responsive: [
                    {
                        breakpoint: 760,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            infinite: false
                        }
                    }
                ]
            });
        }
    }

    function zoomPdp() {
    $(".grid__item.product__media-wrapper media-gallery .slider-mobile-gutter .open-zoom").on("click", function () {
        // pega a posição da thumbnail ativa (garanta que o seletor encontre o elemento certo)
        const currentMediaPosition = $(".grid__item.product__media-wrapper media-gallery .thumbnail-slider .thumbnail-list li.thumbnail-list__item .thumbnail[aria-current]")
        .parent()
        .data("mediaPosition");

        // abre modal
        const $modal = $(".grid__item .modal-custom");
        const $imagesContainer = $modal.find(".content .images");

        $modal.addClass("active");

        // encontra o índice real (zero-based) do img dentro de .images que tem o mesmo data-media-position
        const imgs = $imagesContainer.find("[data-media-position]"); // deve pegar os <img> do modal
        let targetIndex = 0;

        if (typeof currentMediaPosition !== "undefined") {
            // transforma em string para comparar seguro (dataset usa string)
            const currentPosStr = String(currentMediaPosition);

            // procura o índice do elemento que tem data-media-position == currentPosStr
            targetIndex = imgs.toArray().findIndex(el => String($(el).data("mediaPosition")) === currentPosStr);

            // se não encontrou, fallback para 0
            if (targetIndex < 0) targetIndex = 0;
            if (targetIndex >= 1) {
                if (window.location.search.includes('variant=')) {
                    targetIndex = targetIndex - 1;
                }
            } else {
                targetIndex = 1;
            }
        }

        // inicializa o slick já na posição correta
        addSlick(targetIndex);
    });

    $(".grid__item .modal-custom .content .close").on("click", function () {
        $(".grid__item .modal-custom").removeClass("active");
        removeSlick();
    });

    function addSlick(initialIndex) {
        const $slickEl = $(".grid__item .modal-custom .content .images");

        // só inicializa se ainda não estiver inicializado
        if (!$slickEl.hasClass("slick-initialized")) {
        $slickEl.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            initialSlide: initialIndex // aqui já passamos o índice correto
        });
        } else {
        // se já estiver inicializado (caso raro), apenas navega
        $slickEl.slick("slickGoTo", initialIndex);
        }
    }

    function removeSlick() {
        const $slickEl = $(".grid__item .modal-custom .content .images");
        if ($slickEl.hasClass("slick-initialized")) {
        $slickEl.slick("unslick");
        }
    }
    }



    function compreJunto() {
        const cjButton = document.querySelector(".compre-junto__button");

        if (!cjButton) return;

        cjButton.addEventListener("click", function () {
            const mainId = cjButton.dataset.mainId;
            const extraId = cjButton.dataset.extraId;

            cjButton.classList.add('loading');

            if (!mainId || !extraId) return;

            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    items: [
                        { id: mainId, quantity: 1 },
                        { id: extraId, quantity: 1 }
                    ]
                })
            })
                .then(response => response.json())
                .then(data => {
                    cjButton.classList.remove('loading');
                    window.location.href = "/cart";
                })
                .catch(error => {
                    console.error("Erro ao adicionar produtos:", error);
                });
        });
    }

    function handleDescricaoPdp() {
        $(".product__info-container .product__description .content .tit").on('click', function () {
            var self = $(this);
            self.parent().toggleClass('active');
            self.siblings('.resp').slideToggle();
        });
    }

    function compraFlutuante() {
        var $compraFlutuante = $('.product__info-container .compra-flutuante');
        var scrollTrigger = 300;

        $(window).on('scroll', function () {
            var scrollTop = $(this).scrollTop();
            var windowHeight = $(this).height();
            var documentHeight = $(document).height();

            // Se chegou no final da página
            if (scrollTop + windowHeight >= documentHeight - 10) {
                $compraFlutuante.fadeOut();
            }
            // Se passou do trigger, mas não está no final
            else if (scrollTop > scrollTrigger) {
                $compraFlutuante.fadeIn();
            }
            // Antes do trigger
            else {
                $compraFlutuante.fadeOut();
            }
        });
    }

    function slickProdutosRelacionados() {
        setTimeout(() => {
            var qtdeRelated = $(".related-products ul.grid.product-grid li.grid__item").length;
            var quemViu = $(".product-page .collection li.grid__item").length;
            if (window.screen.width > 760) {
                if (qtdeRelated > 5) {
                    $('.related-products ul.grid.product-grid').slick({
                        infinite: false,
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true
                    });
                }
                if (quemViu > 5) {
                    $('.product-page .collection ul.grid.product-grid').slick({
                        infinite: false,
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true
                    });
                }
            } else {
                if (qtdeRelated > 2) {
                    $('.related-products ul.grid.product-grid').slick({
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true
                    });
                }
                 if (quemViu > 2) {
                    $('.product-page .collection ul.grid.product-grid').slick({
                         infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true
                    });
                }
            }
        }, 3000);
    }

    $("div#shopify-section-page-clube .wrapper-clube .box5 p.question").on('click', function () {
        var self = $(this);
        self.parent().toggleClass('active');
        self.siblings('.answer').slideToggle();
    });

    function variationCard() {
        $(".grid__item .card-information .variant-colors .color-swatch").on("click", function () {
            var self = $(this);
            var color = self.data("color");
            var card = self.closest(".grid__item"); // referência ao card atual

            // remove o ativo de todos e adiciona no clicado
            self.siblings().removeClass("active");
            self.addClass("active");

            // esconde todas as imagens do card
            card.find(".card__media .media .variant-images img.variant-image").hide();
            card.find(".card__media .media > img").hide();

            // exibe apenas a imagem com o mesmo data-color
            card.find(`.card__media .media .variant-images img.variant-image[data-color='${color}']`).show();
        });

        $(".grid__item button.quick-add__submit.adicionar-variacoes").on('click', function () {
            var self = $(this);
            self.addClass('loading');

            var card = self.closest(".grid__item");
            var variantId = card.find(".variant-colors .color-swatch.active").data('variant-id');

            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    items: [
                        { id: variantId, quantity: 1 },
                    ]
                })
            })
                .then(response => response.json())
                .then(data => {
                    self.removeClass('loading');

                    // Buscar o cart atualizado do servidor
                    fetch('/cart.js')
                        .then(response => response.json())
                        .then(cartData => {
                            // Atualizar o contador do cart no header
                            const cartCountElements = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
                            cartCountElements.forEach(element => {
                                element.textContent = cartData.item_count;
                            });

                            // Forçar reconstrução completa do cart drawer
                            const cartDrawer = document.querySelector('cart-drawer');
                            if (cartDrawer) {
                                // Remover classe de vazio se existir
                                cartDrawer.classList.remove('is-empty');

                                // Buscar HTML atualizado do cart drawer
                                fetch('/cart?section_id=cart-drawer')
                                    .then(response => response.text())
                                    .then(html => {
                                        // Extrair apenas o conteúdo interno do cart drawer
                                        const tempDiv = document.createElement('div');
                                        tempDiv.innerHTML = html;
                                        const newContent = tempDiv.querySelector('cart-drawer');

                                        if (newContent) {
                                            // Preservar o elemento cart-drawer mas substituir seu conteúdo
                                            cartDrawer.innerHTML = newContent.innerHTML;

                                            // Recriar os event listeners se necessário
                                            if (typeof cartDrawer.setHeaderCartIconAccessibility === 'function') {
                                                cartDrawer.setHeaderCartIconAccessibility();
                                            }
                                        }

                                        // Abrir o cart drawer
                                        setTimeout(() => {
                                            if (typeof cartDrawer.open === 'function') {
                                                cartDrawer.open();
                                            }
                                        }, 150);
                                    });
                            }
                        });
                })
                .catch(error => {
                    console.error("Erro ao adicionar produtos:", error);
                    self.removeClass('loading');
                });
        });

    }

    function variationPdp() {

        const radios = document.querySelectorAll('input[name="id"]');
        
        function onVariantChange() {
            var nameColor = $(".product-form__input--pill input[type=radio]:checked+label span.color-swatch").data('color');
            $("p.selected-color").text(nameColor);
        }

        if (radios && radios.length) {
            radios.forEach(r => r.addEventListener('change', (e) => {
            onVariantChange();
            }));
        }

        onVariantChange();
    }

});